// 地块管理状态
export const FIELD_STATUS = [
  {
    value: 1,
    label: '启用'
  }, {
    value: 2,
    label: '停用'
  }
]
// 地块管理查询，分组状态
export const GROUP_STATUS = [
  {
    value: 1,
    label: '已分组'
  }, {
    value: 2,
    label: '未分组'
  }
]
// 地块类型
export const FIELD_TYPE = [
  {
    value: 1,
    label: '传感器'
  }, {
    value: 2,
    label: '稻田'
  }
]
// 作物类型
export const CROP_TYPE = [
  {
    value: 1,
    label: '水稻'
  }, {
    value: 2,
    label: '玉米'
  },
  {
    value: 3,
    label: '其他'
  }
]
// 种植标准
export const PLANT_STANDARD = [
  {
    value: '1',
    label: '优质绿色'
  }, {
    value: '2',
    label: '核心绿色'
  },
  {
    value: '3',
    label: '有机'
  },
  {
    value: '4',
    label: '双认证'
  },
  {
    value: '5',
    label: '生态'
  }
]
// 作物生长阶段
export const CROP_GROWTH_PHASE = [
  {
    value: 0,
    label: '育苗'
  }, {
    value: 1,
    label: '插秧'
  }, {
    value: 2,
    label: '分蘖'
  },
  {
    value: 3,
    label: '孕穗'
  },
  {
    value: 4,
    label: '抽穗'
  },
  {
    value: 5,
    label: '灌浆'
  },
  {
    value: 6,
    label: '成熟'
  },
  {
    value: 7,
    label: '收割'
  }
]
// 农事类型
export const FARM_OPERATIONS_TYPE = [
  {
    value: 0,
    label: '育苗'
  }, {
    value: 1,
    label: '插秧'
  }, {
    value: 2,
    label: '施肥'
  },
  {
    value: 3,
    label: '灌溉'
  },
  {
    value: 4,
    label: '放鸭'
  },
  {
    value: 5,
    label: '收鸭'
  },
  {
    value: 6,
    label: '收割'
  },
  {
    value: 7,
    label: '除草'
  },
  {
    value: 8,
    label: '防病'
  },
  {
    value: 9,
    label: '杀虫'
  },
  {
    value: 10,
    label: '排水'
  },
  {
    value: 11,
    label: '停止灌溉'
  },
  {
    value: 12,
    label: '停止排水'
  }
]

// 品质等级
export const QUALITY_GRADE = [
  {
    value: 1,
    label: '一级'
  }, {
    value: 2,
    label: '二级'
  }, {
    value: 3,
    label: '三级'
  }
]

// 估算类型
export const ESTIMATION_TYPE = [
  {
    value: 1,
    label: 'AI估算'
  }, {
    value: 2,
    label: '人工估算'
  }
]

// 称重方式
export const WEIGHING_TYPE = [
  {
    value: 1,
    label: '机械称重'
  }, {
    value: 2,
    label: '人工称重'
  }
]

// 采集设备类型
export const CAPTURE_DEVICE_TYPE = [
  {
    value: 1,
    label: '虫情仪'
  }, {
    value: 5,
    label: '无人机'
  }
]

// 风险等级
export const RISK_LEVEL = [
  {
    value: 0,
    label: '轻度'
  }, {
    value: 1,
    label: '中度'
  }, {
    value: 2,
    label: '重度'
  }
]

// 严重程度
export const SEVERITY = [
  {
    value: 0,
    label: '轻度'
  }, {
    value: 1,
    label: '中度'
  }
]

// 长势等级
export const GROWTH_STATUS = [
  {
    value: 1,
    label: '较差'
  }, {
    value: 2,
    label: '一般'
  }, {
    value: 3,
    label: '良好'
  }
]

// 出苗
export const EMERGED = [
  {
    value: 0,
    label: '未出苗'
  }, {
    value: 1,
    label: '已出苗'
  }
]

// 在线状态
export const DEVICE_STATUS = [
  {
    value: 0,
    label: '在线'
  }, {
    value: 1,
    label: '离线'
  }
]

// 运行状态
export const OPERATING_STATUS = [
  {
    value: 0,
    label: '待飞行'
  }, {
    value: 1,
    label: '飞行中'
  }, {
    value: 2,
    label: '返航中'
  }, {
    value: 3,
    label: '充电中'
  }, {
    value: 4,
    label: '保养中'
  }, {
    value: 5,
    label: '待机'
  }
]

// 品质等级
export const STATUS = [
  {
    value: 1,
    label: '待处理'
  }, {
    value: 2,
    label: '处理中'
  }, {
    value: 3,
    label: '已完成'
  }
]

// 品质等级
export const ACADEMY_TYPE = [
  {
    value: 1,
    label: 'Q&A'
  }, {
    value: 2,
    label: '视频'
  }
]

// 品质等级
export const BANNER_TYPE = [
  {
    value: 1,
    label: '产品'
  }, {
    value: 2,
    label: '新闻'
  }
]
